import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import Select from "react-select";

const Sensitisation = ({
  handleChange,
  handleBTDateChange,
  formData,
  postiveNegativeOptions,
  btReasonOptions,
  transfusionTypeOptions,
  pregnancyOutcomeOptions,
  pregnancyStatusOptions,
  transplantOrganOptions,
  transplantReasonOptions,
  transplantOutcomeOptions,
  dialysisVintageOptions,
  dropDownChange,
  placeHolderText,
  style,
  setFormData,
}) => {
  return (
    <div>
      <div className="mb-6">
        <h2 className="mb-4 text-xl font-semibold">
          Panel Reactive Antibody (PRA %)
        </h2>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <label
              htmlFor="pra_class_I"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              PRA Class I
            </label>
            <input
              type="text"
              id="pra_class_I"
              name="pra_class_I"
              min="0"
              step="0.01"
              className="w-full p-2 border rounded-md"
              onChange={handleChange}
              value={formData?.pra_class_I}
            />
          </div>
          <div>
            <label
              htmlFor="pra_class_II"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              PRA Class II
            </label>
            <input
              type="text"
              id="pra_class_II"
              name="pra_class_II"
              min="0"
              step="0.01"
              className="w-full p-2 border rounded-md"
              onChange={handleChange}
              value={formData?.pra_class_II}
            />
          </div>
        </div>
      </div>
      <div className="mb-6">
        <h2 className="mb-4 text-xl font-semibold">Blood Transfusion</h2>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <div>
            <label
              htmlFor="bloodTransfusion_date"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              Transfusion Date
            </label>
            {/* Generate input using DatePicker */}
            <DatePicker
              name="bloodTransfusion_date"
              onChange={handleBTDateChange}
              className="w-full h-10"
              format="YYYY-MM-DD"
              value={
                formData?.bloodTransfusion_date &&
                dayjs(formData?.bloodTransfusion_date, "YYYY-MM-DD")
              }
            />
          </div>
          <div>
            <label
              htmlFor="bloodTransfusion_reason"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              Reason
            </label>
            <Select
              name="bloodTransfusion_reason"
              onChange={dropDownChange}
              options={btReasonOptions}
              //   className={`w-[${inputWidth}] outline-none h-10`}
              placeholder={placeHolderText("Select")}
              styles={style}
              value={
                formData?.bloodTransfusion_reason &&
                btReasonOptions?.find(
                  (option) => option.value === formData?.bloodTransfusion_reason
                )
              }
              menuPosition={"fixed"}
            />
          </div>
          <div>
            <label
              htmlFor="bloodTransfusion_type"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              Transfusion Type
            </label>
            <Select
              name="bloodTransfusion_type"
              onChange={dropDownChange}
              options={transfusionTypeOptions}
              //   className={`w-[${inputWidth}] outline-none h-10`}
              placeholder={placeHolderText("Select")}
              styles={style}
              value={
                formData?.bloodTransfusion_type &&
                transfusionTypeOptions?.find(
                  (option) => option.value === formData?.bloodTransfusion_type
                )
              }
              menuPosition={"fixed"}
            />
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-1">
        <div className="mb-6">
          <label
            htmlFor="bloodTransfusion_notes"
            className="block mb-1 text-sm font-medium text-gray-700"
          >
            Clinical Notes
          </label>
          <textarea
            id="bloodTransfusion_notes"
            name="bloodTransfusion_notes"
            rows="4"
            className="w-full p-2 border rounded-md"
            onChange={handleChange}
            value={formData?.bloodTransfusion_notes || ""}
          />
        </div>
      </div>
      <div className="mb-6">
        <h2 className="mb-4 text-xl font-semibold">
          Pregnancy Details (if Any)
        </h2>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <label
              htmlFor="pregnancyHistory_date_of_delivery"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              Date of Delivery
            </label>
            {/* Generate input using DatePicker */}
            <DatePicker
              name="pregnancyHistory_date_of_delivery"
              onChange={(date, dateString) => {
                setFormData({
                  ...formData,
                  pregnancyHistory_date_of_delivery: dateString,
                });
              }}
              className="w-full h-10"
              format="YYYY-MM-DD"
              value={
                formData?.pregnancyHistory_date_of_delivery &&
                dayjs(formData?.pregnancyHistory_date_of_delivery, "YYYY-MM-DD")
              }
            />
          </div>
          <div>
            <label
              htmlFor="pregnancyHistory_number_of_pregnancies"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              Number of Pregnancies
            </label>
            <input
              type="number"
              id="pregnancyHistory_number_of_pregnancies"
              min="0"
              name="pregnancyHistory_number_of_pregnancies"
              className="w-full p-2 border rounded-md"
              onChange={handleChange}
              value={formData?.pregnancyHistory_number_of_pregnancies}
            />
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-1">
        <div className="mb-6">
          <label
            htmlFor="pregnancyHistory_notes"
            className="block mb-1 text-sm font-medium text-gray-700"
          >
            Clinical Notes
          </label>
          <textarea
            id="pregnancyHistory_notes"
            name="pregnancyHistory_notes"
            rows="4"
            className="w-full p-2 border rounded-md"
            onChange={handleChange}
            value={formData?.pregnancyHistory_notes || ""}
          />
        </div>
      </div>
      <div className="mb-6">
        <h2 className="mb-4 text-xl font-semibold">Transplant History</h2>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
          <div>
            <label
              htmlFor="transplantHistory_date"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              Transplant Date
            </label>
            {/* Generate input using DatePicker */}
            <DatePicker
              name="transplantHistory_date"
              onChange={(date, dateString) => {
                setFormData({
                  ...formData,
                  transplantHistory_date: dateString,
                });
              }}
              className="w-full h-10"
              format="YYYY-MM-DD"
              value={
                formData?.transplantHistory_date &&
                dayjs(formData?.transplantHistory_date, "YYYY-MM-DD")
              }
            />
          </div>
          <div>
            <label
              htmlFor="transplantHistory_organ"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              Organ
            </label>
            <Select
              name="transplantHistory_organ"
              onChange={dropDownChange}
              options={transplantOrganOptions}
              //   className={`w-[${inputWidth}] outline-none h-10`}
              placeholder={placeHolderText("Select")}
              styles={style}
              value={
                formData?.transplantHistory_organ &&
                transplantOrganOptions?.find(
                  (option) => option.value === formData?.transplantHistory_organ
                )
              }
              menuPosition={"fixed"}
            />
          </div>
          <div>
            <label
              htmlFor="transplantHistory_graft_failure_reason"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              Graft Failure Reason
            </label>
            <Select
              name="transplantHistory_graft_failure_reason"
              onChange={dropDownChange}
              options={transplantReasonOptions}
              //   className={`w-[${inputWidth}] outline-none h-10`}
              placeholder={placeHolderText("Select")}
              styles={style}
              value={
                formData?.transplantHistory_graft_failure_reason &&
                transplantReasonOptions?.find(
                  (option) =>
                    option.value ===
                    formData?.transplantHistory_graft_failure_reason
                )
              }
              menuPosition={"fixed"}
            />
          </div>
          <div>
            <label
              htmlFor="transplantHistory_dialysis_vintage"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              Dialysis Vintage
            </label>
            <Select
              name="transplantHistory_dialysis_vintage"
              onChange={dropDownChange}
              options={dialysisVintageOptions}
              //   className={`w-[${inputWidth}] outline-none h-10`}
              placeholder={placeHolderText("Select")}
              styles={style}
              value={
                formData?.transplantHistory_dialysis_vintage &&
                dialysisVintageOptions?.find(
                  (option) =>
                    option.value ===
                    formData?.transplantHistory_dialysis_vintage
                )
              }
              menuPosition={"fixed"}
            />
            {/* <input
              type="number"
              id="transplantHistory_dialysis_vintage"
              min="0"
              name="transplantHistory_dialysis_vintage"
              className="w-full p-2 border rounded-md"
              onChange={handleChange}
              value={formData?.transplantHistory_dialysis_vintage}
            /> */}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-1">
        <div className="mb-6">
          <label
            htmlFor="transplantHistory_notes"
            className="block mb-1 text-sm font-medium text-gray-700"
          >
            Clinical Notes
          </label>
          <textarea
            id="transplantHistory_notes"
            name="transplantHistory_notes"
            rows="4"
            className="w-full p-2 border rounded-md"
            onChange={handleChange}
            value={formData?.transplantHistory_notes || ""}
          />
        </div>
      </div>
    </div>
  );
};

export default Sensitisation;
